<template>
    <div class="course-card">
        <div class="row">
            <div class="col-12 col-md-2">
                <router-link :to="{ name: 'course.details', params: { slug: course.slug }}">
                    <img
                            class="rounded img-fluid"
                            v-if="course.caticon"
                            :src="course.caticon"
                    >

                    <img
                            class="rounded img-fluid"
                            src="@/assets/hometeacher/images/home-kurs-none.png"
                            v-else
                    >
                </router-link>
            </div>

            <div class="col-12 col-md-10">
                <div class="row align-items-center mb-3">
                    <div class="col">
                        <img
                                class="course-card-title__badge"
                                :src="require(`@/assets/hometeacher/images/${difficlty}.png`)"
                        >

                        <router-link
                                class="course-card-title h1"
                                :to="{ name: 'course.details', params: { slug: course.slug }}"
                        >
                            {{ course.course }}
                            <span class="course-card-title__language">{{ language }}</span>
                        </router-link>
                    </div>

                    <div class="col-auto">
                        <router-link
                                class="course-card__button course-card__button--red btn"
                                :to="{ name: 'course.details', params: { slug: course.slug }}"
                        >
                            {{ $t('view_course') }}
                            <i class="fa fa-arrow-right ml-2"></i>
                        </router-link>
                    </div>
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-sm-4">
                        <CourseStatistic :course="course"/>
                    </div>
                    <div class="col-sm-8">
                        <div class="col-sm-12 course-card__description"
                             v-html="course.description"
                        ></div>
                        <div class="col-sm-12 kurs mt-5" v-if="course.isAdditionalPackage">
                            <div :class="['dop-pack', 'activated']">
                                <div class="dop-pack-name">{{ $t('dop_pack_title') }}:</div>
                                <div class="dop-pack-expand" v-if="!expanded" @click="expanded=true"><span>{{ $t('dop_pack_composition') }}</span>
                                </div>
                                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_1') }}</div>
                                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_2') }}</div>
                                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_3') }}</div>
                                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_4') }}</div>
                                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_5') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- /.row -->
        <div class="row course-pays" v-if="coursePayments.length">
            <div class="col-12 col-md-2">
            </div>
            <div class="col-12 col-md-6">
                <div class="course-pay-header">
                    {{ $t('pays_for_course') }} <span v-if="coursePayments[0].partial">{{ coursePayments.length }} {{ $t('from') }} {{ coursePayments[0].partial_pay_count }} {{ $t('pays') }}:</span>
                </div>
                <div class="course-pay-item" v-for="(pay, index) in coursePayments" :key="pay.id">
                    <span class="course-pay-id" v-if="coursePayments[0].partial">{{ $t('pay') }} {{$t('№')}}{{ index + 1 }}</span>
                    <span class="course-pay-id" v-else>{{ $t('pay') }}</span>
                    <span class="course-pay-amount-label">{{ $t('on_amount') }}</span>
                    <span class="course-pay-amount">{{ pay.price | formatPrice }}{{ $t('cur') }}</span>
                    <span class="course-pay-date last">{{ pay.paydate | formatDate }}</span>
                </div>
                <div class="course-pay-debt"
                     v-if="coursePayments[0].partial && coursePayments.length < coursePayments[0].partial_pay_count">
                    {{ $t('pays_remain') }}: {{ coursePayments[0].partial_pay_count - coursePayments.length }}, {{
                    $t('on_amount') }}
                    {{ ( coursePayments[0].partial_pay_count - coursePayments.length ) * coursePayments[0].price }}{{
                    $t('cur') }}
                </div>


            </div>
            <div class="col-12 col-md-4 zapis"
                 v-if="coursePayments[0].partial && coursePayments.length < coursePayments[0].partial_pay_count">

                <div v-if="course.flRecurrent" @click.prevent="uncheckRecurrent" class="course-recurrent-option">
                    <base-checkbox :checked="true" class="mt-4 custom-control-alternative danger">
                        {{ $t('reccurent_notice') }}
                    </base-checkbox>
                </div>

                <base-button
                        :data-id="course.idcourse"
                        data-model="course"
                        :data-price="coursePayments[0].price"
                        data-action="gotoPayment"
                        :data-label="$t('go_to_payment')"
                        type="primary"
                        class="btn-block mt-5"
                        @click="gotoPayment"
                >
                    <span>{{ $t('go_to_payment') }} {{coursePayments[0].price | formatPrice}}{{ $t('cur') }}</span>
                    <i class="fa fa-arrow-right ml-2"></i>
                </base-button>

            </div>
        </div>
    </div>
</template>

<script>
    import courseApi from '@/data/CourseApi';
    import CourseStatistic from './CourseStatistic';
    import numeral from 'numeral';
    import moment from 'moment';

    export default {
        name: 'CourseCard',

        props: {
            course: {
                type: Object,
                required: true,
            },
            coursePayments: {
                type: Array,
                required: false,
                default: null,
            }
        },
        data() {
            return {
                expanded: false,
                activated: false,
            }
        },
        created() {
            moment.locale(this.$i18n.locale)
        },
        methods: {
            gotoPayment() {
                let params = ['partial']
                this.$router.push('/payment/' + this.course.idcourse + (params.length ? ('?' + params.join('&')) : ''))
            },

            uncheckRecurrent() {
                this.$emit("uncheck-recurrent", this.course);
            },
        },
        computed: {
            language() {
                return this.course.idlanguage ? courseApi.getLanguageName(this.course.idlanguage) : '';
            },

            difficlty() {
                return this.course.difficulty
                    ? courseApi.getDifficultyName(this.course.difficulty).toLowerCase()
                    : 'easy';
            },
        },
        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            },
            formatDate: function (value) {
                return moment(value).format('DD MMMM YYYY')
            }
        },
        components: {
            CourseStatistic,
        }
    }
</script>

<style scoped>
    .dop-pack-expand {
        font-size: 14px;
        color: #0489c7;
    }

    .dop-pack-expand span {
        border-bottom: 1px solid #0489c7;
        position: relative;
        cursor: pointer;
    }

    .dop-pack-expand span::after {
        display: block;
        content: ' ';
        height: 5px;
        width: 10px;
        background-image: url('~@/assets/hometeacher/images/expand-down-blue.png');
        position: absolute;
        right: -15px;
        top: 7px;
    }

</style>


<style src="@/assets/hometeacher/css/main.css"></style>
